import { ContentSubmissionActionTypes } from './contentSubmissionActions';
import { SET_CONTENT_SUBMISSION_MODAL_OPEN } from './contentSubmissionTypes';

export interface ContentSubmissionState {
  isModalOpen: boolean;
}

const initialState: ContentSubmissionState = {
  isModalOpen: false,
};

const contentSubmissionReducer = (
  state: ContentSubmissionState = initialState,
  action: ContentSubmissionActionTypes
): ContentSubmissionState => {
  switch (action.type) {
    case SET_CONTENT_SUBMISSION_MODAL_OPEN:
      return {
        ...state,
        isModalOpen: action.payload,
      };
    default:
      return state;
  }
};

export default contentSubmissionReducer;
